import styled, { css } from 'styled-components'
import { pb, pt } from 'styled-components-spacing'

import { colors } from 'bl-common/src/constants/colors'
import { base } from 'bl-common/src/constants/sizes'
import { LinkArrow } from 'bl-common/src/elements/Arrow/Arrow'
import { Link } from 'bl-common/src/elements/Link'
import { Type } from 'bl-common/src/elements/Typography/Typography'
import { useBreakpoints } from 'bl-common/src/hooks/useBreakpoints'
import { media, mediaMax } from 'bl-common/src/utils/media'

type WrapProps = {
  top?: any
  bottom?: any
}
const Wrap = styled.span<WrapProps>`
  display: inline-flex;
  align-items: baseline;

  ${({ top, theme }) => pt(top, theme)};
  ${({ top }) =>
    top?.xs &&
    mediaMax.md(css`
      padding-top: ${top.xs * base}px;
    `)};

  ${({ bottom, theme }) => pb(bottom, theme)};
  ${({ bottom }) =>
    bottom?.xs &&
    mediaMax.md(css`
      padding-bottom: ${bottom.xs * base}px;
    `)};

  > *:first-child:not(:last-child) {
    margin-right: 16px;
    ${media.md(css`
      margin-right: ${({ theme }) => theme.spacing[1]};
    `)}
  }
`

export const BackToStoriesLink = ({ top, bottom, to = '/stories' }) => {
  const { isMobile } = useBreakpoints()

  return (
    <Link to={to}>
      <Wrap top={top} bottom={bottom}>
        <LinkArrow
          rotate={180}
          width={18}
          height={isMobile ? 8 : 12}
          fill={colors.deepBlue}
        />
        <Type
          color={colors.deepBlue}
          size={{ xs: 10, md: 14, lg: 16 }}
          weight="bold"
        >
          Back to Blue Lagoon stories
        </Type>
      </Wrap>
    </Link>
  )
}
